import React, { Component } from 'react';
import { setProdSelc, delProdSelc, setCurrentTab } from './../../redux/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import api from './../../utilites/api';
import ListProdutos from './../../fragments/listProdutos'
import Skeleton from '@material-ui/lab/Skeleton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';


// import { Container } from './styles';

class Cardapio extends Component {
  state = {
    produtos: [],
    produtosOr: [],
    isLoading: false,
    colorHeader: "#991e25",
    consulta: ''
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    const data = new FormData();
    data.append('id_grupo', this.props.location.state.grupo);

    try {
      const response = await api.post('ws/ListProd.php', data);
      console.log('respostaPR: ', response.data)
      if (response.status === 200) {
        this.setState({
          produtos: response.data,
          produtosOr: response.data,
        });
      } else {
        alert('Erro na comunicação com  servidor!', 'Atenção', false);
      }

    } catch (error) {
      alert('Erro na comunicação com servidor!', 'Atenção', false);
    }

    this.setState({ isLoading: false });
  }

  componentWillUnmount() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }

  listProd() {
    const { delProdSelc, setProdSelc } = this.props;
    
    if (this.state.produtos.length === 0 && this.state.consulta.trim().length > 0) {
      return (
        <div style={{ 
          padding: '40px 20px',
          textAlign: 'center',
        }}>
          <div style={{
            fontSize: 48,
            marginBottom: 16,
          }}>🔍</div>
          <h3 style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: '#666',
            margin: '0 0 8px 0',
          }}>
            Nenhum produto encontrado
          </h3>
          <p style={{
            fontSize: 14,
            color: '#999',
            margin: 0,
          }}>
            Tente buscar com outros termos
          </p>
        </div>
      );
    }

    // Função para destacar o termo buscado
    const highlight = (text) => {
      const busca = this.state.consulta;
      if (!busca || !text) return text;
      const regex = new RegExp(`(${busca.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
      return String(text).split(regex).map((part, i) =>
        regex.test(part)
          ? <span key={i} style={{ background: '#ffe066', color: '#a52a2a', fontWeight: 700 }}>{part}</span>
          : part
      );
    };

    return (
      <div style={{ 
        padding: '0 20px 72px 20px',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
      }}>
        {this.state.produtos.map((i, index) => (
          <div key={index} style={{
            background: '#fff',
            borderRadius: 16,
            boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
            border: '1px solid rgba(0,0,0,0.05)',
            overflow: 'hidden',
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)';
          }}>
            <ListProdutos 
              Imagem={i.imagem} 
              Nome={this.state.consulta.trim().length > 0 ? highlight(i.nome) : i.nome} 
              Obs={this.state.consulta.trim().length > 0 ? highlight(i.obs) : i.obs} 
              Preco={i.preco} 
              acao={() => {
                delProdSelc();
                setProdSelc(i);
                this.props.history.push({
                  pathname: '/Produto',
                  state: {
                    pp: i
                  }
                })
              }} 
            />
          </div>
        ))}
      </div>
    )
  }

  formS() {
    return (
      <div style={{ padding: '0 20px' }}>
        <Skeleton variant="rect" height={80} style={{ 
          marginBottom: 16, 
          borderRadius: 16,
          background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
        }} />
        <Skeleton variant="rect" height={80} style={{ 
          marginBottom: 16, 
          borderRadius: 16,
          background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
        }} />
        <Skeleton variant="rect" height={80} style={{ 
          marginBottom: 16, 
          borderRadius: 16,
          background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
        }} />
        <Skeleton variant="rect" height={80} style={{ 
          marginBottom: 16, 
          borderRadius: 16,
          background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
        }} />
        <Skeleton variant="rect" height={80} style={{ 
          marginBottom: 16, 
          borderRadius: 16,
          background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
        }} />
      </div>
    )
  }

  getValorCarrinho() {
    var vl = 0.00;

    this.props.carr.carrinho.map(i => (
      vl = parseFloat(vl) + parseFloat(i.preco)
    ))

    return this.mascaraValor(vl.toFixed(2))
  }

  mascaraValor(valor) {
    valor = valor.toString().replace(/\D/g, "");
    valor = valor.toString().replace(/(\d)(\d{8})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{5})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{2})$/, "$1,$2");
    return valor
  }

  header() {
    return (
      <div style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        display: "flex", 
        justifyContent: 'space-between', 
        height: 64, 
        paddingLeft: 0, 
        paddingRight: 20, 
        background: 'linear-gradient(135deg, #a52a2a 0%, #8b0000 100%)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        borderBottom: '3px solid rgba(255,255,255,0.2)',
      }}>
        <div style={{ marginLeft: 20, marginTop: 16, display: "flex", alignItems: 'center' }}>
          <button 
            style={{ 
              background: 'none',
              border: 'none',
              padding: 8,
              borderRadius: '50%',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s ease',
              width: 48,
              height: 48,
            }} 
            onClick={() => this.props.history.goBack()}
            onMouseEnter={(e) => e.target.style.background = 'rgba(255,255,255,0.1)'}
            onMouseLeave={(e) => e.target.style.background = 'none'}
          >
            <ArrowBackIcon style={{ color: '#fff', fontSize: 24 }} />
          </button>
          <div style={{ marginLeft: 12 }}>
            <label style={{ 
              fontSize: 24, 
              fontWeight: "bold", 
              color: '#fff',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)',
              letterSpacing: 0.5,
            }}>
              Cardápio
            </label>
          </div>
        </div>
      </div>
    );
  }

  handlePresquisa = () => {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    
    this.searchTimeout = setTimeout(() => {
      var temp = this.state.produtosOr;
      
      if (this.state.consulta.trim().length === 0) {
        this.setState({ produtos: temp });
        return;
      }
      
      let result = temp.filter((item) => { 
        return item.nome.toLowerCase().includes(this.state.consulta.toLowerCase()) ||
               (item.obs && item.obs.toLowerCase().includes(this.state.consulta.toLowerCase()))
      });
      
      this.setState({ produtos: result });
    }, 300); // 300ms debounce
  }

  render() {
    return (
      <div style={{ 
        background: 'linear-gradient(to bottom, #f8f9fa 0%, #ffffff 20%)', 
        minHeight: '100vh' 
      }}>
        <div style={{flex: 1}}>
          {this.header()}
          
          {/* Espaçador para compensar o header fixo */}
          <div style={{ height: 80 }}></div>
          
          {/* Seção do título da categoria */}
          <div style={{ 
            padding: '20px 24px',
            background: '#fff',
            borderRadius: '16px 16px 0 0',
            marginTop: -8,
            boxShadow: '0 -2px 20px rgba(0,0,0,0.05)',
          }}>
            <div style={{
              textAlign: 'center',
              marginBottom: 20,
            }}>
              <h2 style={{ 
                fontSize: 22, 
                fontWeight: "bold", 
                color: '#333',
                margin: 0,
                textShadow: '0 1px 2px rgba(0,0,0,0.1)',
              }}>
                {this.props.location.state.nome}
              </h2>
              <div style={{
                width: 60,
                height: 3,
                background: 'linear-gradient(90deg, #a52a2a 0%, #8b0000 100%)',
                borderRadius: 2,
                margin: '8px auto 0',
              }} />
            </div>
            
            {/* Barra de pesquisa */}
            <div style={{ 
              position: 'relative', 
              marginBottom: 8,
              maxWidth: 400,
              margin: '0 auto',
            }}>
              <input
                type="text"
                placeholder="Buscar produtos..."
                value={this.state.consulta}
                onChange={(e) => {
                  this.setState({ consulta: e.target.value });
                  this.handlePresquisa();
                }}
                style={{
                  padding: '12px 44px 12px 16px',
                  fontSize: 16,
                  width: '100%',
                  borderRadius: 20,
                  border: '2px solid #a52a2a',
                  outline: 'none',
                  boxShadow: this.state.consulta.length > 0 ? '0 2px 12px rgba(165, 42, 42, 0.2)' : 'none',
                  background: '#fff',
                  color: '#333',
                  fontWeight: 500,
                  transition: 'all 0.3s ease',
                  boxSizing: 'border-box',
                }}
              />
              {/* Ícone de lupa */}
              <span style={{ 
                position: 'absolute', 
                right: 16, 
                top: '50%', 
                transform: 'translateY(-50%)', 
                color: '#a52a2a', 
                fontSize: 20, 
                pointerEvents: 'none' 
              }}>
                <svg width="20" height="20" fill="none" stroke="#a52a2a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                  <circle cx="11" cy="11" r="8"/>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
              </span>
            </div>
          </div>
          
          {/* Lista de produtos */}
          <div style={{ 
            background: '#fff',
            padding: '0 0 100px 0',
          }}>
            {this.state.isLoading ? this.formS() : this.listProd()}
          </div>
        </div>

        {Object.entries(this.props.carr.carrinho).length > 0 ?
          <div style={{
            background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
            position: 'fixed',
            left: 0,
            bottom: 0,
            width: '100%',
            height: 64,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            zIndex: 1000,
            padding: '0 20px',
            boxShadow: '0 -4px 20px rgba(0,0,0,0.15)',
            borderTop: '2px solid rgba(255,255,255,0.2)',
          }}>
            <button 
              style={{ 
                flex: 1, 
                display: 'flex', 
                alignItems: 'center', 
                minWidth: 0,
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '8px 0',
              }} 
              onClick={() => {
                const { setCurrentTab } = this.props;
                setCurrentTab(1);
                this.props.history.goBack()
              }}
            >
              <label style={{ 
                color: '#fff', 
                fontSize: 15, 
                whiteSpace: 'nowrap', 
                overflow: 'hidden', 
                textOverflow: 'ellipsis',
                fontWeight: '600',
                textShadow: '0 1px 2px rgba(0,0,0,0.2)',
                cursor: 'pointer',
              }}>
                Valor: € {this.getValorCarrinho()}
              </label>
            </button>
            <button 
              style={{ 
                marginLeft: 24, 
                display: 'flex', 
                alignItems: 'center', 
                minWidth: 0,
                background: 'rgba(255,255,255,0.2)',
                border: 'none',
                borderRadius: 12,
                padding: '12px 16px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
              }} 
              onClick={() => {
                const { setCurrentTab } = this.props;
                setCurrentTab(1);
                this.props.history.goBack()
              }}
              onMouseEnter={(e) => e.target.style.background = 'rgba(255,255,255,0.3)'}
              onMouseLeave={(e) => e.target.style.background = 'rgba(255,255,255,0.2)'}
            >
              <ShoppingCartIcon style={{ color: 'white', fontSize: 20, marginRight: 8 }} />
              <label style={{ 
                color: 'white', 
                fontSize: 15, 
                fontWeight: 600,
                cursor: 'pointer',
                textShadow: '0 1px 2px rgba(0,0,0,0.2)',
              }}>
                Finalizar Pedido
              </label>
            </button>
          </div> : null
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  preodSelc: state.SelecReducer,
  carr: state.CarrinhoReducer
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setProdSelc, delProdSelc, setCurrentTab }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Cardapio);
